import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface CreditCardPaymentStyles {
  disclaimer: Styles
}

interface CreditCardPaymentStylesProps {
  isFormOpen: boolean
}

export const useStyles = createUseStyles<CreditCardPaymentStyles, CreditCardPaymentStylesProps>((theme) => {
  return {
    disclaimer: ({ isFormOpen }) => ({
      opacity: isFormOpen ? theme.opacity.opaque : theme.opacity.transparent,
      transition: isFormOpen ? 'all 0.3s ease-in' : 'opacity 0.3s ease-out',
      marginTop: theme.calcUnit(theme.spacing.s3),
    }),
  }
})
